<template>
  <div>
    <v-snackbar color="success" v-model="success" :timeout="1">{{
      success
    }}</v-snackbar>
    <v-snackbar color="error" v-model="error" :timeout="1">{{
      error
    }}</v-snackbar>
    <v-dialog v-model="dialog" width="500" v-if="isAdmin">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          x-small
          class="hideIt"
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon x-small>mdi-pencil</v-icon></v-btn
        >
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ name }} ({{ code }})
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field
            placeholder="Add new alias"
            required
            v-model="alias"
            @keypress.enter="submitter()"
          ></v-text-field>
          <v-slide-y-transition>
            <loading v-if="loading" message="Submitting..."></loading>
          </v-slide-y-transition>
          <v-slide-y-transition>
            <loading
              v-if="aliasesLoading"
              message="Getting current aliases..."
            ></loading>
          </v-slide-y-transition>
          <div v-if="existingAliases">
            <span class="overline">Existing aliases</span>
            <ul>
              <li v-for="eAlias in existingAliases" :key="eAlias.id">
                {{ eAlias.alias }}
              </li>
            </ul>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Cancel</v-btn
          ><v-btn depressed color="primary" @click="submitter()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import AdminMixin from "@/assets/js/AdminMixin";

export default {
  name: "AddAlias",
  components: {
    Loading: () => import("@/components/universalStuff/Loading"),
  },
  mixins: [AdminMixin],
  props: {
    code: null,
    name: null,
  },
  data: function () {
    return {
      dialog: false,
      valid: false,
      alias: null,
      error: null,
      success: null,
      loading: false,
      aliasesLoading: false,
      existingAliases: null,
      // isAdmin: false, this comes from the adminMixin
    };
  },
  methods: {
    getExistingAliases() {
      // ApiServices.aliasesForCode(this.code)
      ApiServices.genericApiCall("/icd/aliasesForCode/" + this.code)
        .then((response) => {
          this.aliasesLoading = false;
          this.existingAliases = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An error occurred";
          this.aliasesLoading = false;
        });
    },
    submitter() {
      if (!this.alias) return;
      if (!this.code || !this.name) return;
      this.loading = true;
      this.success = null;
      this.error = null;
      let adminUser = this.$store.state.admin;
      let encodedAlias = encodeURIComponent(this.alias);
      ApiServices.addAlias(this.code, this.name, encodedAlias, adminUser)
        .then((response) => {
          if (response.data.error) this.error = response.data.error;
          if (response.data.success) this.success = response.data.success;
          this.loading = false;
          this.dialog = false;
          this.alias = null;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An error occurred";
          this.loading = false;
        });
    },
  },
  computed: {},
  mounted: function () {
    //if (this.code && this.isAdmin) this.getExistingAliases();
    // let adminUser = localStorage.getItem("adminUser");
    // console.log(adminUser);
    // if (adminUser) this.isAdmin = true;
    // localStorage.setItem("adminUser", "01070507");
  },
  watch: {
    // code() {
    //   this.getExistingAliases();
    // },
    dialog(val) {
      if (val && !this.existingAliases) this.getExistingAliases();
    },
  },
};
</script>

<style scoped></style>
